import { gql } from '@apollo/client'

export const SUBMIT_INSURANCE_INFORMATION = gql`
  mutation submitInsuranceInformation(
    $insurancePlan: String!
    $memberId: String
    $groupNumber: String
    $policyHolder: String
    $policyHolderFirstName: String
    $policyHolderLastName: String
    $policyHolderDateOfBirth: ISO8601Date
  ) {
    submitInsuranceInformation(
      insurancePlan: $insurancePlan
      memberId: $memberId
      groupNumber: $groupNumber
      policyHolder: $policyHolder
      policyHolderFirstName: $policyHolderFirstName
      policyHolderLastName: $policyHolderLastName
      policyHolderDateOfBirth: $policyHolderDateOfBirth
    ) {
      completionDeepLink
    }
  }
`
